
export class CONST {
  public static readonly ITEM_PER_PAGE = 250;
  public static readonly DEFAULT_CURRENCY = 'usd';
  public static readonly DEFAULT_PRICE_CHANGE_PERCENT = '1h,24h,7d';
  public static readonly TOTAL_PAGE = 10;
  public static readonly REFRESH_INTERVAL = 60000;
}

export class LOCAL_KEYS {
  public static readonly FAVORITES = 'market_favorites';
  public static readonly MARKET_SORT = 'market_sort';
  public static readonly PORTFOLIO = 'market_portfolio';
  public static readonly LANGUAGE = 'current_language';
  public static readonly APP_STARTED = 'app_started';
  public static readonly USER_INFO = 'userInfo';
  public static readonly NOTIFICATIONS = 'notifications_enabled';
  public static readonly PENDING_REFERRAL_CODE = 'pendingReferralCode';
  // Acceptation de l'écran d'avertissement / conditions d'utilisation (voir disclaimer.page.ts,
  // gate dans app.component.ts). Suffixe versionné : bump si le contenu légal change
  // substantiellement, pour re-présenter l'écran à tout le monde.
  public static readonly DISCLAIMER_ACCEPTED = 'disclaimerAcceptedV1';
}

export function normalizeLeaderboardReferralCode(input?: string | null): string {
  const raw = (input ?? '').trim();
  if (!raw) return '';

  let value = raw;
  try {
    const url = new URL(raw);
    value =
      url.searchParams.get('startapp') ??
      url.searchParams.get('start') ??
      url.searchParams.get('ref') ??
      raw;
  } catch {
    const startapp = raw.match(/[?&]startapp=([^&#]+)/i)?.[1];
    if (startapp) value = decodeURIComponent(startapp);
  }

  value = value.trim();
  if (/^(lc|course_)/i.test(value)) return '';
  if (/^0x[a-f0-9]{40}$/i.test(value)) return '';
  return /^[a-z0-9]{4,100}$/i.test(value) ? value.toUpperCase() : '';
}
